const requestMediaDevicesPermissions = async ({ dispatch, openPopUp, popupType }) => {
  if (!navigator?.mediaDevices?.getUserMedia) {
    return { canJoin: false, cameraAvailable: false };
  }

  try {
    const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
    audioStream.getTracks().forEach((track) => track.stop());
  } catch (_error) {
    if (typeof dispatch === 'function') {
      dispatch(openPopUp(popupType));
    }
    return { canJoin: false, cameraAvailable: false };
  }

  try {
    const videoStream = await navigator.mediaDevices.getUserMedia({ audio: false, video: true });
    videoStream.getTracks().forEach((track) => track.stop());
    return { canJoin: true, cameraAvailable: true };
  } catch (_error) {
    if (typeof dispatch === 'function') {
      dispatch(openPopUp(popupType));
    }
    return { canJoin: true, cameraAvailable: false };
  }
};

export default requestMediaDevicesPermissions;
